module.exports = __webpack_public_path__ + "static/img/newanli-04.860eaadc.jpg";